(function() {
  'use strict';

  // Fonction pour récupérer les images des produits BYOB
  function getBYOBProductImages() {
    const images = [];
    const thumbnails = document.querySelectorAll('.byob-footer-thumbnail-image img');
    
    thumbnails.forEach(img => {
      if (img.src && img.src.trim() !== '' && img.title) {
        // Ajouter l'image avec son titre
        images.push({
          src: img.src,
          title: img.title
        });
      }
    });
    
    return images;
  }

  // Fonction pour remplir les cadres avec les images
  function fillFrames() {
    const productImages = getBYOBProductImages();
    const frames = document.querySelectorAll('.byob-frame, .byob-extra-frame');
    
    // Vider tous les cadres d'abord
    frames.forEach(frame => {
      frame.innerHTML = '';
      frame.style.backgroundImage = 'none';
    });
    
    // Remplir les cadres avec les images disponibles
    productImages.forEach((product, index) => {
      if (index < frames.length) {
        const img = document.createElement('img');
        img.src = product.src;
        img.alt = product.title;
        img.title = product.title;
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
        frames[index].appendChild(img);
      }
    });
    
    console.log(`${productImages.length} produits BYOB affichés dans le visualiseur`);
  }

  // Ouvrir la modal
  function openModal() {
    const modal = document.getElementById('byob-visualizer-modal');
    if (modal) {
      fillFrames(); // Remplir les cadres avant d'ouvrir
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }
  }

  // Fermer la modal
  function closeModal() {
    const modal = document.getElementById('byob-visualizer-modal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  // Initialisation
  function init() {
    // Bouton d'ouverture
    const openButton = document.querySelector('.byob-visualizer-button');
    if (openButton) {
      openButton.addEventListener('click', openModal);
    }

    // Bouton de fermeture
    const closeButton = document.querySelector('.byob-visualizer-close');
    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }

    // Fermer en cliquant sur l'overlay
    const overlay = document.querySelector('.byob-visualizer-overlay');
    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }

    // Observer les changements dans le panier BYOB
    const byobFooter = document.querySelector('.byob-footer');
    if (byobFooter) {
      const observer = new MutationObserver(() => {
        // Si la modal est ouverte, mettre à jour les cadres
        const modal = document.getElementById('byob-visualizer-modal');
        if (modal && modal.style.display === 'block') {
          fillFrames();
        }
      });

      observer.observe(byobFooter, {
        childList: true,
        subtree: true
      });
    }

    console.log('BYOB Visualizer initialisé!');
  }

  // Attendre que le DOM soit chargé
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
